export const fields = [
  { name: "macros", type: "array", defaultValue: [], required: false },
  { name: "micros", type: "array", defaultValue: [], required: false },
];

export const label = "Business Environment";
